import { Component, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import { AppService } from '../../../../services/app.service';
import { IStudyQualityEvaluationEditModel, StudyQualityEvaluationStatus } from '../../../../models/StudyQualityEvaluation';
import { StudyQualityEvaluationService } from '../../../../services/study-quality-evaluation.service';
import { IPlanSummaryResident } from '../../../../models/PlanSummary';


@Component({
    selector: 'app-study-quality-evaluation-reject-evaluation',
    templateUrl: './study-quality-evaluation-reject-evaluation.component.html',
})
export class StudyQualityEvaluationRejectEvaluationComponent {
    constructor(
        private app: AppService,
        private service: StudyQualityEvaluationService,
        private activeModal: NgbActiveModal,
    ) { }

    @Input() model: IStudyQualityEvaluationEditModel;
    @Input() resident: IPlanSummaryResident;

    submitted: boolean;
    isSaving: boolean;
    isSubmitting: boolean;

    @ViewChild('form', { static: true }) private form: NgForm;

    save(submit: boolean = false) {
        if (this.form.invalid) {
            this.submitted = true;
            return;
        }

        const success = () => {
            this.activeModal.close(true);
        };


        if (submit) { // Return back to supervisor for reevaluation
            this.isSubmitting = true;

            this.model.Status = StudyQualityEvaluationStatus.Draft;
            this.model.ResidencyAccepted = false;
        } else {
            this.isSaving = true;

            this.model.Status = StudyQualityEvaluationStatus.Residency;
        }

        this.model.ResidencyCondition = null;
        this.model.ResidencyDeadline = null;

        const call = this.service.saveResidencyEvaluation(this.resident.StudentId, this.model);

        this.app.addLoading(call).pipe(finalize(() => submit ? this.isSubmitting = false : this.isSaving = false)).subscribe(success);
    }

    cancel() {
        this.activeModal.close(false);
    }
}
